export const ROUTES = {
  // Public marketing / funnel pages
  TRADINGVIEW_LANDING:            '/tradingview-auto-trading-india',
  TRADINGVIEW_LANDING_THANK_YOU:  '/tradingview-auto-trading-india/thank-you',

  // Auth
  LOGIN:            '/login',
  SIGNUP:           '/signup',
  VERIFY:           '/verify',
  FORGOT_PASSWORD:  '/forgot-password',
  RESET_PASSWORD:   '/reset-password',
  CHANGE_PASSWORD:  '/change-password',

  // Chrome extension secure connect flow (Phase 2F)
  EXTENSION_CONNECT: '/extension/connect',

  // User workspace
  PROFILE:          '/profile',
  BROKER:           '/broker',
  BROKER_ORDERS:    '/broker/orders',
  BROKER_ORDERBOOK: '/broker/orderbook',
  BROKER_POSITIONS: '/broker/positions',
  BROKER_HOLDINGS:  '/broker/holdings',

  PORTFOLIO:           '/portfolio',
  PORTFOLIO_ORDERS:    '/portfolio/orders',
  PORTFOLIO_POSITIONS: '/portfolio/positions',
  PORTFOLIO_HOLDINGS:  '/portfolio/holdings',

  DASHBOARD:        '/dashboard',
  STRATEGIES:       '/strategies',
  STRATEGIES_CREATE: '/strategies/create',
  STRATEGIES_NEW:   '/strategies/new',
  STRATEGY_EDIT:    '/strategies/:id/edit',
  SIGNALS:          '/signals',
  MANUAL_TRADING:   '/manual-trading',
  DISPATCH_LOGS:    '/dispatch-logs',
  LOGS:             '/logs',

  OPTIONS:          '/options',
  OPTIONS_NEW:      '/options/new',
  OPTIONS_DETAIL:   '/options/:id',
  OPTIONS_DEPLOY:   '/options/:id/deploy',

  ADMIN_OVERVIEW:        '/admin/overview',
  ADMIN_USERS:           '/admin/users',
  ADMIN_USER_DETAIL:     '/admin/users/:id',
  ADMIN_RUNTIME:    '/admin/runtime',
  ADMIN_DISPATCH:   '/admin/dispatch',
  ADMIN_CANDLES:          '/admin/candles',
  ADMIN_MARKET_CALENDAR:  '/admin/market-calendar',
  ADMIN_USER_STRATEGIES:  '/admin/user-strategies',

  SUBSCRIPTION:          '/subscription',
  ADMIN_PLANS:           '/admin/plans',           // legacy redirect
  ADMIN_LICENSE_PACKS:   '/admin/license-packs',
  ADMIN_SUBSCRIPTION_PLANS: '/admin/subscription-plans',
  ADMIN_PROXY:           '/admin/proxy',
  ADMIN_TRADING_AUDIT:   '/admin/trading-audit',
  ADMIN_WEBSITE_LEADS:    '/admin/website/leads',
  ADMIN_WEBSITE_ARTICLES: '/admin/website/articles',
  ADMIN_PAYMENTS:         '/admin/payments',
  ADMIN_GOOGLE_REVIEWS:   '/admin/google-reviews',
  OPERATOR_PLANS:        '/operator/plans',
  OPERATOR_RECHARGE:     '/operator/recharge',
  OPERATOR_PAYMENT_SETTINGS: '/operator/payment-settings',
  OPERATOR_BRANDING_SETTINGS: '/operator/branding-settings',

  strategy:        (id) => `/strategies/${id}`,
  strategyEdit:    (id) => `/strategies/${id}/edit`,
  options:         (id) => `/options/${id}`,
  optionsDeploy:   (id) => `/options/${id}/deploy`,
  adminUserDetail: (id) => `/admin/users/${id}`,
};

export function resolvePageTitle(pathname) {
  if (pathname === '/dashboard')                        return 'Dashboard';
  if (pathname === '/strategies')                       return 'Strategies';
  if (pathname === '/strategies/create')                return 'New Strategy';
  if (pathname === '/strategies/new')                   return '';
  if (pathname.match(/^\/strategies\/\d+\/edit/))       return 'Edit Strategy';
  if (pathname === '/signals')                          return 'Signals';
  if (pathname === '/manual-trading')                   return 'Manual Trading';
  if (pathname === '/dispatch-logs')                    return 'Dispatch Logs';
  if (pathname === '/logs')                             return 'Runtime Logs';
  if (pathname === '/options/new')                      return '';
  if (pathname.match(/^\/options\/[^/]+\/deploy/))      return 'Deploy Option Strategy';
  if (pathname.match(/^\/options\/[^/]+/))              return 'Option Strategy';
  if (pathname === '/options')                          return 'O For Option';
  if (pathname === '/admin/overview')                   return 'Admin — Overview';
  if (pathname === '/admin/users')                      return 'Admin — Users';
  if (pathname === '/admin/runtime')                    return 'Admin — Runtime';
  if (pathname === '/admin/dispatch')                   return 'Admin — Dispatch';
  if (pathname === '/admin/candles')                    return 'Admin — Candle Inspector';
  if (pathname === '/admin/market-calendar')            return 'Admin — Market Calendar';
  if (pathname === '/admin/user-strategies')            return 'Admin — User Strategies';
  if (pathname.match(/^\/admin\/users\/\d+/))           return 'Admin — User Detail';
  if (pathname === '/profile')                          return 'Profile';
  if (pathname === '/broker')                           return 'Broker';
  if (pathname === '/broker/orderbook')                 return 'Orderbook';
  if (pathname === '/broker/positions')                 return 'Position Book';
  if (pathname === '/broker/holdings')                  return 'Holdings';
  if (pathname.startsWith('/portfolio'))                return 'Portfolio';
  if (pathname === '/subscription')                     return 'Subscription';
  if (pathname === '/admin/plans')                      return 'Admin — Plans & Licenses';
  if (pathname === '/admin/license-packs')              return 'Admin — License Packs';
  if (pathname === '/admin/subscription-plans')         return 'Admin — Subscription Plans';
  if (pathname === '/admin/proxy')                      return 'Admin — Proxy IPs';
  if (pathname === '/operator/plans')                   return 'Subscription Plans';
  if (pathname === '/operator/recharge')                return 'Recharge';
  if (pathname === '/operator/payment-settings')        return 'Payment Gateway';
  if (pathname === '/operator/branding-settings')       return 'Branding Settings';
  if (pathname === '/admin/website/leads')              return 'Admin — Website Leads';
  if (pathname === '/admin/website/articles')           return 'Admin — Website Articles';
  if (pathname === '/admin/payments')                   return 'Admin — Payments';
  if (pathname === '/admin/google-reviews')             return 'Admin — Google Reviews';
  return 'ALGOSYS';
}

export const USER_NAV = [
  { to: ROUTES.STRATEGIES,    label: 'Strategies',    icon: 'Zap' },
  { to: ROUTES.SIGNALS,       label: 'Signals',       icon: 'Activity' },
  { to: ROUTES.MANUAL_TRADING, label: 'Manual Trading', icon: 'Send' },
  { to: ROUTES.LOGS,          label: 'Runtime Logs',  icon: 'FileText' },
  { to: ROUTES.OPTIONS,       label: 'O For Option',  icon: 'Layers' },
  { to: ROUTES.BROKER,        label: 'Broker',        icon: 'Link' },
  { to: ROUTES.PORTFOLIO,     label: 'Portfolio',     icon: 'Briefcase' },
  { to: ROUTES.SUBSCRIPTION,  label: 'Subscription',  icon: 'CalendarCheck' },
];

export const OPERATOR_NAV = [
  { to: ROUTES.STRATEGIES,         label: 'Strategies',         icon: 'Zap' },
  { to: ROUTES.SIGNALS,            label: 'Signals',            icon: 'Activity' },
  { to: ROUTES.MANUAL_TRADING,     label: 'Manual Trading',     icon: 'Send' },
  { to: ROUTES.LOGS,               label: 'Runtime Logs',       icon: 'FileText' },
  { to: ROUTES.OPTIONS,            label: 'O For Option',       icon: 'Layers' },
  { to: ROUTES.BROKER,             label: 'Broker',             icon: 'Link' },
  { to: ROUTES.PORTFOLIO,          label: 'Portfolio',          icon: 'Briefcase' },
  { to: ROUTES.OPERATOR_PLANS,     label: 'Subscription Plans', icon: 'CreditCard' },
  { to: ROUTES.OPERATOR_RECHARGE,  label: 'Recharge',           icon: 'Wallet' },
  { to: ROUTES.OPERATOR_PAYMENT_SETTINGS, label: 'Payment Gateway', icon: 'Receipt' },
  { to: ROUTES.OPERATOR_BRANDING_SETTINGS, label: 'Branding Settings', icon: 'Palette' },
];

export const OPERATOR_ADMIN_NAV = [
  { to: ROUTES.ADMIN_USERS,           label: 'Users',              icon: 'Users' },
  { to: ROUTES.ADMIN_RUNTIME,         label: 'Runtime Logs',       icon: 'Cpu' },
  { to: ROUTES.ADMIN_TRADING_AUDIT,   label: 'Trading Audit',      icon: 'ClipboardList' },
  { to: ROUTES.OPERATOR_PLANS,        label: 'Subscription Plans', icon: 'CreditCard' },
  { to: ROUTES.OPERATOR_RECHARGE,     label: 'Recharge',           icon: 'Wallet' },
  { to: ROUTES.OPERATOR_PAYMENT_SETTINGS, label: 'Payment Gateway', icon: 'Receipt' },
  { to: ROUTES.OPERATOR_BRANDING_SETTINGS, label: 'Branding Settings', icon: 'Palette' },
];

export const ADMIN_NAV = [
  { to: ROUTES.ADMIN_OVERVIEW,          label: 'Overview',            icon: 'Shield'           },
  { to: ROUTES.ADMIN_USERS,             label: 'Users',               icon: 'Users'            },
  { to: ROUTES.ADMIN_USER_STRATEGIES,   label: 'User Strategies',     icon: 'ScrollText'       },
  { to: ROUTES.ADMIN_RUNTIME,           label: 'Runtime',             icon: 'Cpu'              },
  { to: ROUTES.ADMIN_DISPATCH,          label: 'Dispatch',            icon: 'Send'             },
  { to: ROUTES.ADMIN_CANDLES,           label: 'Candle Inspector',    icon: 'CandlestickChart' },
  { to: ROUTES.ADMIN_MARKET_CALENDAR,   label: 'Market Calendar',     icon: 'CalendarDays'     },
  { to: ROUTES.ADMIN_LICENSE_PACKS,     label: 'License Packs',       icon: 'Package'          },
  { to: ROUTES.ADMIN_SUBSCRIPTION_PLANS, label: 'Subscription Plans', icon: 'CreditCard'       },
  { to: ROUTES.ADMIN_TRADING_AUDIT,    label: 'Trading Audit',       icon: 'ClipboardList'    },
  { to: ROUTES.ADMIN_PROXY,            label: 'Proxy IPs',           icon: 'Network'          },
  { to: ROUTES.ADMIN_WEBSITE_LEADS,     label: 'Website Leads',    icon: 'Globe',    superAdminOnly: true },
  { to: ROUTES.ADMIN_WEBSITE_ARTICLES, label: 'Articles',          icon: 'FileText', superAdminOnly: true },
  { to: ROUTES.ADMIN_PAYMENTS,         label: 'Payments',          icon: 'Receipt',  superAdminOnly: true },
  { to: ROUTES.ADMIN_GOOGLE_REVIEWS,   label: 'Google Reviews',    icon: 'Star',     superAdminOnly: true },
];

// Mobile bottom nav (4 items max)
export const MOBILE_NAV = [
  { to: ROUTES.STRATEGIES,     label: 'Strategies', icon: 'Zap' },
  { to: ROUTES.MANUAL_TRADING, label: 'Trade',      icon: 'Send' },
  { to: ROUTES.PORTFOLIO,      label: 'Portfolio',  icon: 'Briefcase' },
  { to: ROUTES.SIGNALS,        label: 'Signals',    icon: 'Activity' },
];
